export default "__VITE_ASSET__wG_HyO_F__"